module.exports = __webpack_public_path__ + "img/20210906-1630910965154235.6b8c56ef.jpg";